import React from 'react';

import { type FPlatformUserFragment } from '@dashboard/generated/wp/authentication';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { alertError, alertSuccess } from '@wp-react/notifications';

import useDeletePlatformUser from '../../useDeletePlatformUser';

type Props = {
  platformUser: FPlatformUserFragment;
  onClose: () => void;
};
export default function DeleteUserConfirmationDialog({ platformUser, onClose }: Props) {
  const [deleteUser, { loading }] = useDeletePlatformUser();

  const onSubmit = async () => {
    const { data } = await deleteUser({ platformUserId: platformUser.id });

    if (data?.deletePlatformUser) {
      alertSuccess(`'${platformUser.emailAddress || platformUser.displayName}' has been removed from this workspace`);
    } else {
      alertError('Failed to remove team member');
    }
    onClose();
  };

  return (
    <Dialog open onClose={onClose} maxWidth="xs">
      <DialogTitle>Remove this team member?</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to remove <strong>{platformUser.emailAddress || platformUser.displayName}</strong> from
          this workspace?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button disabled={loading} color="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button disabled={loading} type="submit" variant="contained" color="error" onClick={onSubmit}>
          Yes, remove
        </Button>
      </DialogActions>
    </Dialog>
  );
}
